type SelectedFile = {
  resourceType?: string;
  fileId?: string;
};

type SelectedFilesMap = Record<string, SelectedFile>;

export const checkIfFilesAreAttachedForIssues = (listOfSelectedFiles: SelectedFilesMap): SelectedFile[] => {
  const attachedIssues = Object.values(listOfSelectedFiles).filter(
    (issue) => issue.resourceType == "RESOURCE_TYPE_ISSUE",
  );
  const allFilesAttached = Object.keys(listOfSelectedFiles);

  const filteredIssues: SelectedFile[] = [];

  attachedIssues.forEach((issue: any) => {
    if (!allFilesAttached.includes(issue.fileId!)) {
      filteredIssues.push(issue);
    }
  });
  return filteredIssues;
};
